// src/firebase/firebase.js
// Single Firebase instance shared across the entire app.
// All other files import from here — never import Firebase directly elsewhere.

let _db   = null;
let _app  = null;

export let fbRef, fbSet, fbGet, fbUpdate, fbOnValue, fbPush, fbRemove;

export const FIREBASE_CONFIG = {
  apiKey:            "AIzaSyDXvaqomiAUiO9Bd8YVupwTDQeWuLqkjvc",
  authDomain:        "omerta-mafia-game.firebaseapp.com",
  databaseURL:       "https://omerta-mafia-game-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId:         "omerta-mafia-game",
  storageBucket:     "omerta-mafia-game.firebasestorage.app",
  messagingSenderId: "167145326962",
  appId:             "1:167145326962:web:dd4c7f18a7820c913d75eb",
};

export async function initFirebase() {
  if (_db) return true;
  try {
    const { initializeApp, getApps } = await import(
      "https://www.gstatic.com/firebasejs/10.12.0/firebase-app.js"
    );
    const fb = await import(
      "https://www.gstatic.com/firebasejs/10.12.0/firebase-database.js"
    );

    fbRef     = fb.ref;
    fbSet     = fb.set;
    fbGet     = fb.get;
    fbUpdate  = fb.update;
    fbOnValue = fb.onValue;
    fbPush    = fb.push;
    fbRemove  = fb.remove;

    // Reuse existing app if already initialised (HMR safe)
    const existing = getApps().find((a) => a.name === "omerta");
    _app = existing || initializeApp(FIREBASE_CONFIG, "omerta");
    _db  = fb.getDatabase(_app);
    return true;
  } catch (e) {
    console.error("[Firebase] init error:", e);
    return false;
  }
}

export function getDb() {
  return _db;
}

// ── Convenience wrappers (always use these, never call fbXxx directly) ──

export function dbRef(path) {
  return fbRef(getDb(), path);
}

export async function dbSet(path, value) {
  return fbSet(dbRef(path), value);
}

export async function dbGet(path) {
  return fbGet(dbRef(path));
}

export async function dbUpdate(path, value) {
  return fbUpdate(dbRef(path), value);
}

export async function dbPush(path, value) {
  return fbPush(dbRef(path), value);
}

export async function dbRemove(path) {
  return fbRemove(dbRef(path));
}

/** Returns an unsubscribe function */
export function dbListen(path, cb) {
  const unsubscribe = fbOnValue(dbRef(path), cb);
  return unsubscribe;
}
